import { Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { BaseService } from '../shared/services/base.service';
import { Observable } from 'rxjs/internal/Observable';

@Pipe({
    name: 'secure',
    standalone: false
})
export class SecurePipe implements PipeTransform {

    constructor(
            private baseService:BaseService
         ) { }

    transform(url): Observable<SafeUrl> {
        return this.baseService.getFileByUrl(url);
    }

}